import { renderSection } from '@/contentful';
import * as React from 'react';
import { PageSectionFieldsFragment, PageSectionsBySystemIdQuery } from 'types/generated';
import { ArcGISProvider } from './ArcGISContext';
import dynamic from 'next/dynamic';
import '@arcgis/core/assets/esri/themes/light/main.css';
import InfoSetSection from '../InfoSetSection';

// Dynamically import RoamingMap, ensuring no SSR for it
const ArcGISServiceMap = dynamic(() => import('./MapWithControls/ArcGISServiceMap'), {
  ssr: false,
});

type Props = {
  sections: Array<PageSectionsBySystemIdQuery>;
  orderedIds: Array<string>;
  token: string;
};

const ServiceMap = ({ sections, orderedIds, token }: Props) => {
  const pageSections = sections
    .flatMap((x) => x.pageSectionCollection?.items as PageSectionFieldsFragment[])
    .sort((a, b) => orderedIds.indexOf(a.sys.id) - orderedIds.indexOf(b.sys.id));

  const firstInfoSetSection = pageSections.find((section) => section.children?.__typename === 'InfoSet');
  const filteredSections = pageSections.filter((section) => section.id !== firstInfoSetSection?.id);
  const firstInfoSet = firstInfoSetSection?.children?.__typename === 'InfoSet' ? firstInfoSetSection.children : null;

  return (
    <>
      {firstInfoSet && <InfoSetSection infoSetId={firstInfoSet.sys.id} classes="grid !bg-white-15 md:!col-start-3" />}
      <ArcGISProvider token={token}>
        <ArcGISServiceMap />
      </ArcGISProvider>
      {filteredSections.map((s, index) => renderSection(s, index === 0))}
    </>
  );
};

export default ServiceMap;
